<template>
	<div>
		<el-table :data="list" border size="mini">
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('coupon_index.name')"></el-table-column>
			<el-table-column prop="coupon_type" align="center" :label="$t('coupon_index.coupon_type')">
				<template slot-scope="{row}">{{COUPON_TYPE[row.coupon_type][lang=='cn'?'name_cn':'name']}}</template>
			</el-table-column>
			<el-table-column prop="credit_amount" align="center" :label="$t('coupon_index.credit_amount')">
				<template slot-scope="{row}">
					<p v-if="row.coupon_type==1">￥{{row.price}}</p>
					<p v-if="row.coupon_type==2">{{row.discount}}%</p>
				</template>
			</el-table-column>
			<el-table-column prop="menkan" align="center" :label="$t('coupon_index.menkan')"></el-table-column>
			<el-table-column prop="is_diejia" align="center" :label="$t('coupon_index.superposition')">
				<template slot-scope="{row}">{{COUPON_OVERLAY[row.is_diejia][lang=='cn'?'name_cn':'name']}}</template>
			</el-table-column>
			<el-table-column prop="all_times" align="center" :label="$t('coupon_index.all_times')"></el-table-column>
			<el-table-column prop="get_way" align="center" :label="$t('coupon_index.get_type')" :key="50">
				<template slot-scope="{row}">{{COUPON_TRIGGER_TYPE[row.get_way][lang=='cn'?'name_cn':'name']}}</template>
			</el-table-column>
			<el-table-column prop="remark" align="center" :label="$t('parent_index.remarks')" :key="51"></el-table-column>
			<el-table-column prop="is_used" align="center" :label="$t('coupon_index.is_use')" :key="60">
				<template slot-scope="{row}">
					<span>{{is_use[row.is_used][lang=='cn'?'name_cn':'name']}}</span>
					<span v-if="row.is_used==1">{{row.order_id}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" v-if="scope.row.is_used==0" @click="del(scope.row)" data-name="删除">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			is_use:{
				0:{
					name:"NO",
					name_cn:"否"
				},
				1:{
					name:"YES",
					name_cn:"是"
				}
			},
			COUPON_TYPE:[],
			COUPON_OVERLAY:[],
			COUPON_TRIGGER_TYPE:[]
		}
	},
	props:{
		user_id: {
			type: Number,
			default:0
		},
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		config() {
			var url = "getDictionaryValue";
			var datas = {
				code: "COUPON_TYPE,COUPON_COLLECTION_TYPE,COUPON_OVERLAY,COUPON_TRIGGER_TYPE,COUPON_STATUS"
			};
			this.$post(url, datas).then((res) => {
				this.COUPON_TYPE = this.for_code(res.COUPON_TYPE);
				this.COUPON_OVERLAY = this.for_code(res.COUPON_OVERLAY);
				var COUPON_TRIGGER_TYPE = this.for_code(res.COUPON_TRIGGER_TYPE);
				this.COUPON_TRIGGER_TYPE = {
					...COUPON_TRIGGER_TYPE,
					99:{
						name:"receive",
						name_cn:"领取"
					},
					100:{
						name:"Background distribution",
						name_cn:"后台发放"
					}
				}
				this.init();
			})
		},
		for_code(list){
			var new_list = {};
			for (var i = 0; i < list.length; i++) {
				new_list[list[i].code] = list[i];
			}
			return new_list
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "UserCouponRecord";
			var datas = {
				user_id:this.user_id,
			};
			this.$post(url, datas).then((res) => {
				this.list = res;
			})
		},
		del(data){
			var url = "deletePrivateUserCoupon";
			var datas={
				id:data.id
			}
			this.$confirm(this.$t('index.confirm_delete'), this.$t('index.tips')).then(() => {
				this.$post(url,datas).then((res) => {
					this.$message.success(this.$t('index.operation_success'));
					this.init();
				})
			})
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
	display: flex;
}
.page-pagination {
	padding: 20px 10px;
}
.filter-panel {
/* 	width: calc(100% - 135px); */
/* 	float: left; */
flex: 1;
}
.line {
	font-size: 26px;
	cursor: pointer;
	margin-top: 30px;
}
.dialog-footer{
	text-align: right;
	margin-bottom: 20px;
}
.input_yincang{
	width: 0;
	height: 0;
	position: relative;
	overflow: hidden;
}
.input_yincang>div{
	position: absolute;left: 100px;
	top: 100px;
}
</style>
<style>
textarea{
	font-family:inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/parent/components/coupon_list.vue